var DashboardDisplayType;
(function (DashboardDisplayType) {
    DashboardDisplayType[DashboardDisplayType["Auto"] = 0] = "Auto";
    DashboardDisplayType[DashboardDisplayType["Fixed"] = 1] = "Fixed";
    DashboardDisplayType[DashboardDisplayType["Mobile"] = 2] = "Mobile";
})(DashboardDisplayType || (DashboardDisplayType = {}));
// copied from node_modules/angular-gridster2/lib/gridsterConfig.interface.d.ts so this doesn't depend on gridster
// also, import type doesn't work here since these are enums, and nx would recognize it as a dependency anyway
var DashboardDisplayGrid;
(function (DashboardDisplayGrid) {
    DashboardDisplayGrid["Always"] = "always";
    DashboardDisplayGrid["OnDragAndResize"] = "onDrag&Resize";
    DashboardDisplayGrid["None"] = "none";
})(DashboardDisplayGrid || (DashboardDisplayGrid = {}));
var DashboardCompactType;
(function (DashboardCompactType) {
    DashboardCompactType["None"] = "none";
    DashboardCompactType["CompactUp"] = "compactUp";
    DashboardCompactType["CompactLeft"] = "compactLeft";
    DashboardCompactType["CompactUpAndLeft"] = "compactUp&Left";
    DashboardCompactType["CompactLeftAndUp"] = "compactLeft&Up";
    DashboardCompactType["CompactRight"] = "compactRight";
    DashboardCompactType["CompactUpAndRight"] = "compactUp&Right";
    DashboardCompactType["CompactRightAndUp"] = "compactRight&Up";
})(DashboardCompactType || (DashboardCompactType = {}));
const DEFAULT_PALLETE = 'primary';
const STATUS_PALETTE = 'state';
function createDefaultDashboardSettings() {
    return {
        width: 1920,
        height: 1080,
        displayType: DashboardDisplayType.Auto,
        gridConfig: {
            pushItems: true,
            compactType: DashboardCompactType.None,
            displayGrid: DashboardDisplayGrid.OnDragAndResize,
        },
        generalPalette: DEFAULT_PALLETE,
    };
}
var DashboardPermission;
(function (DashboardPermission) {
    DashboardPermission["Read"] = "R";
    DashboardPermission["Write"] = "W";
    DashboardPermission["Admin"] = "A";
})(DashboardPermission || (DashboardPermission = {}));

var PaletteType;
(function (PaletteType) {
    PaletteType["General"] = "general";
    PaletteType["Status"] = "status";
})(PaletteType || (PaletteType = {}));

function createEmptyDashboard() {
    return { type: 'root', element: undefined, children: [] };
}

class TrackingService {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    track(_module, _event, _data = {}, _single = undefined) {
        // noop
    }
    flush() {
        // noop
    }
}
const defaultTrackingServiceProvider = { provide: TrackingService, useClass: TrackingService };

/**
 * Generated bundle index. Do not edit.
 */

export { DEFAULT_PALLETE, DashboardCompactType, DashboardDisplayGrid, DashboardDisplayType, DashboardPermission, PaletteType, STATUS_PALETTE, TrackingService, createDefaultDashboardSettings, createEmptyDashboard, defaultTrackingServiceProvider };
